module.exports = __webpack_public_path__ + "static/media/matilde-bored.69f9c9a0.png";